import { Navbar } from "../components/site/Navbar";
import { HeroSlider } from "../components/site/HeroSlider";
import { About } from "../components/site/About";
import { BrandTicker } from "../components/site/BrandTicker";
import { Categories } from "../components/site/Categories";
import { Stats } from "../components/site/Stats";
import { Services } from "../components/site/Services";
import { HowWeWork } from "../components/site/HowWeWork";
import { Footer } from "../components/site/Footer";

export default function Home() {
  return (
    <div className="bg-navy min-h-screen text-cream" data-testid="home-page">
      <Navbar />
      <main>
        <HeroSlider />
        <About />
        <BrandTicker />
        <Categories />
        <Stats />
        <Services />
        <HowWeWork />
      </main>
      <Footer />
    </div>
  );
}
